import { css } from 'aphrodite';
import { ISelectOption } from '../../../../web/components/DeprecatedSelect';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../web/components-v2/Select';
import { grayIconFill } from '../../../styles/colors';
import { Group } from '../../leadView/components/Group';
import { styleSheet } from '../styles';

interface IProps<T> {
	defaultSelected?: ISelectOption<T>;
	description: string;
	disabled?: boolean;
	onSelect: (option: ISelectOption<T>) => void;
	selectOptions: ISelectOption<T>[];
}

export function GeneralSettingsItem<T>({ defaultSelected, description, disabled, onSelect, selectOptions }: IProps<T>) {
	const handleValueChange = (id: string) => {
		const option = selectOptions.find(o => o.id === id);
		if (option) {
			onSelect(option);
		}
	};
	return (
		<Group vCentered={true}>
			<div className={css(styleSheet.regularText)} style={{ color: disabled ? grayIconFill : null }}>
				{description}
			</div>
			<Select disabled={disabled} value={defaultSelected?.id} onValueChange={handleValueChange}>
				<SelectTrigger>
					<span>{defaultSelected?.text ?? 'Select...'}</span>
				</SelectTrigger>
				<SelectContent>
					{selectOptions.map(option => (
						<SelectItem key={option.id} value={option.id}>
							{option.text}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</Group>
	);
}
